let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iW52P")).then(() => parcelRequire('kdaCi'));